export default function SearchError(message, request = null) {
  this.name = "SearchError";
  this.message = message || "";
  this.request = request;
}
SearchError.prototype = new Error();
